export const iconFontAwesomeArrowsArrowPointer = (
	<i className="fa-solid fa-arrow-pointer"></i>
);
